import { createEntityAdapter, createSlice, EntityId } from '@reduxjs/toolkit';
import { Status } from 'enums/messages';
import type { RootState } from 'store';

import { OrderNoteProps, OrderNotesState } from './orderNotes.types';
import { orderNotesApiSlice } from './orderNotesApi';

const orderNotesAdapter = createEntityAdapter<OrderNoteProps, EntityId>({
  selectId: (note) => note._id,
  sortComparer: (a, b) => a.createdAt.localeCompare(b.createdAt)
});

const initialState: OrderNotesState = {
  loadingStatus: Status.Idle,
  orderNotesList: orderNotesAdapter.getInitialState()
};

const orderNotesSlice = createSlice({
  extraReducers: (builder) => {
    builder
      .addMatcher(orderNotesApiSlice.endpoints.getOrderNotes.matchPending, (state) => {
        state.loadingStatus = Status.Pending;
      })
      .addMatcher(orderNotesApiSlice.endpoints.getOrderNotes.matchFulfilled, (state, action) => {
        state.loadingStatus = Status.Fulfilled;
        orderNotesAdapter.upsertMany(state.orderNotesList, action.payload);
      })
      .addMatcher(orderNotesApiSlice.endpoints.getOrderNotes.matchRejected, (state) => {
        state.loadingStatus = Status.Rejected;
      })
      .addMatcher(
        orderNotesApiSlice.endpoints.createOrderNote.matchFulfilled,
        (state, { payload }) => {
          orderNotesAdapter.upsertOne(state.orderNotesList, payload);
        }
      )
      .addMatcher(
        orderNotesApiSlice.endpoints.updateOrderNote.matchFulfilled,
        (state, { payload }) => {
          orderNotesAdapter.upsertOne(state.orderNotesList, payload);
        }
      );
  },
  initialState,
  name: 'orderNotes',
  reducers: {
    clearOrderNotes: () => initialState
  }
});

export const orderNotesSelectors = orderNotesAdapter.getSelectors<RootState>(
  (state) => state.orderNotes.orderNotesList
);

export const selectOrderNotes = (state: RootState) => state.orderNotes;

export const { clearOrderNotes } = orderNotesSlice.actions;

export default orderNotesSlice.reducer;
